export const isArrayWithValues = value =>
  Array.isArray(value) && value.length > 0;

export const isObjectWithKeys = value =>
  value instanceof Object &&
  value.constructor === Object &&
  Object.keys(value).length > 0;

export const isPositiveValue = value => parseInt(value, 10) >= 0;
